//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// FormField
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export class FormField {

    //Currently, these are the only values we expect to vary by user role
    read_only = false;
    show = true;


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(read_only, show){
        if (read_only) { this.read_only = read_only; }
        if (show) { this.show = show; }
    };

}